import * as types from './mutation-types.js'
import creatives from '@/services/api/host_read'
import api from '@/services/api'

const state = {
  adCreative: null,
  adCreativeCount: 0,
  adCreatives: [],
  pendingAdCreatives: 0
}

const actions = {
  clearAdCreative ({state, commit}) {
    commit(types.CLEAR_AD_CREATIVE)
  },
  clearAdCreatives ({state, commit}) {
    commit(types.CLEAR_AD_CREATIVES)
  },
  async createAdCreativeAudio ({state}, {path, filename}) {
    let result = await creatives.createAdCreativeAudio(path, {file_name: filename})

    return result
  },
  async getAdCreative ({state, commit}, path) {
    let result = await creatives.getAdCreative(path)

    commit(types.SET_AD_CREATIVE, result)
    return result
  },
  async getAdCreatives ({state, commit}, {path, options}) {
    let result = await creatives.getAdCreatives(path, options)

    commit(types.SET_AD_CREATIVES, result.collection)
    commit(types.SET_AD_CREATIVE_COUNT, result.count)
    commit(types.SET_PENDING_AD_CREATIVE_COUNT, result.active_count)
    return result
  },
  async getAdCreativeAudio ({ state, commit }, {audio}) {
    return api.get.data(audio)
  },
  async updateAdCreative ({state, commit}, {path, payload}) {
    let result = await creatives.updateAdCreative(path, payload)

    commit(types.SET_AD_CREATIVE, result)
    return result
  }
}

const mutations = {
  [types.CLEAR_AD_CREATIVE] (state) {
    state.adCreative = null
  },
  [types.CLEAR_AD_CREATIVES] (state) {
    state.adCreatives = []
    state.adCreativeCount = 0
  },
  [types.SET_AD_CREATIVE] (state, creative) {
    state.adCreative = creative
  },
  [types.SET_AD_CREATIVES] (state, creatives) {
    state.adCreatives = creatives
  },
  [types.SET_AD_CREATIVE_COUNT] (state, count) {
    state.adCreativeCount = count
  },
  [types.SET_PENDING_AD_CREATIVE_COUNT] (state, count) {
    state.pendingAdCreatives = count
  }
}

const getters = {
  adCreative: state => state.adCreative,
  adCreativesCount: state => state.adCreativeCount,
  adCreatives: state => state.adCreatives,
  pendingAdCreatives: state => state.pendingAdCreatives
}

export default {
  state,
  actions,
  mutations,
  getters
}
